import { render, staticRenderFns } from "./PlanSettingsBudget.vue?vue&type=template&id=1f2970c6"
import script from "./PlanSettingsBudget.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsBudget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports